import React from 'react'
import MessageComponet from '../../components/Message/MessageComponet'
import InstitutionMessage from '../../components/Message/InstitutionMessage';
import { useSelector } from 'react-redux';

const Message = () => {
  const { roleType } = useSelector((state) => state.auth);
  if (roleType === "superadmin") {
    return (
      <div><MessageComponet /></div>
    )
  }
  else {
    return (
      <InstitutionMessage />
    )
  }

}

export default Message